import React, { useContext, useState } from 'react';
//import {withRouter} from 'react-router';
import GlobalContext from './../../../contexts/GlobalContext';
import FooterModal from './FooterModal';
import './Footer.css';
import useFromSelfCheckin from "../../../hooks/useFromSelfCheckin";
/**
 * Component Footer
 */
const Footer = (props) => {
  const [globalContext] = useContext(GlobalContext);
  const [typeModalState, setTypeModalState] = useState('privacyPolicy');
  const [modalVisibleState, setModalVisibleState] = useState(false);
  const fromSelfCheckin = useFromSelfCheckin(props.location);

  const handleHideModal = () => {
    document.body.classList.remove('modal-fade-in');
    setModalVisibleState(false);
  }

  const handleShowModal = (event) => {
    setModalVisibleState(true);
    setTypeModalState(event.target.id);
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <footer id="footer" className={fromSelfCheckin.isFromSelfCheckin ? "footer-fromSelfCheckin" : ""}>
      <div id="infosLegales">
        <label id="privacyPolicy" onClick={handleShowModal}>
          {globalContext.translations.privacyPolicy}
        </label>
        &nbsp;-&nbsp;
        <label id="cgv" onClick={handleShowModal}>
          {globalContext.translations.salesTermsAndConditions}
        </label>
      </div>
      <label id="copyRight">
        Powered by MisterBooking
      </label>
      <div id="background-svg" className={fromSelfCheckin.isFromSelfCheckin ? "background-fromSelfCheckin" : ""}/>
      <FooterModal type={typeModalState} isVisible={modalVisibleState} handleClose={handleHideModal} translations={globalContext.translations} legalInfo={globalContext.legalInfo}/>
    </footer>
  )
}

export default Footer;